import { RouteRecordRaw } from 'vue-router';

import ChatAudienceView from '@/views/chat/ChatAudienceView.vue';
import ChatGeneralView from '@/views/chat/ChatGeneralView.vue';
import ChatMeetingView from '@/views/chat/ChatMeetingView.vue';
import ChatSingleView from '@/views/chat/ChatSingleView.vue';
import SelfServiceChatLayout from '@/views/layout/SelfServiceChatLayout.vue';
import SelfServiceLayout from '@/views/layout/SelfServiceLayout.vue';
import SelfServiceChatListView from '@/views/self-service/SelfServiceChatListView.vue';
import SelfServiceContactView from '@/views/self-service/SelfServiceContactView.vue';
import SelfServiceDashboardView from '@/views/self-service/SelfServiceDashboardView.vue';
import SelfServiceHistoryView from '@/views/self-service/SelfServiceHistoryView.vue';
import SelfServiceOnboardingView from '@/views/self-service/SelfServiceOnboardingView.vue';
import SelfServicePlanChangeView from '@/views/self-service/SelfServicePlanChangeView.vue';
import SelfServicePlanSettingsView from '@/views/self-service/SelfServicePlanSettingsView.vue';
import SelfServicePolicyView from '@/views/self-service/SelfServicePolicyView.vue';

export default function selfServiceRoutes(): RouteRecordRaw[] {
  return [
    {
      path: '/ss',
      name: 'self-service',
      redirect: () => ({ name: 'ss-dashboard' }),
      component: SelfServiceLayout,
      meta: { requiresAuth: true, domain: 'SELF_SERVICE' },
      children: [
        // 대시보드
        {
          path: '/ss/dashboard',
          name: 'ss-dashboard',
          component: SelfServiceDashboardView,
        },
        // 통역
        {
          path: '/ss/chat',
          name: 'ss-chat-entrance',
          redirect: () => ({ name: 'ss-chat-conference' }),
          component: SelfServiceChatLayout,
          children: [
            // 컨퍼런스
            {
              path: '/ss/chat/conference',
              name: 'ss-chat-conference',
              component: ChatGeneralView,
              meta: { chatType: 'CONFERENCE' },
            },
            // 미팅
            {
              path: '/ss/chat/meeting',
              name: 'ss-chat-meeting',
              component: ChatMeetingView,
              meta: { chatType: 'MEETING' },
            },
            // 청취
            {
              path: '/ss/chat/audience',
              name: 'ss-chat-audience',
              component: ChatAudienceView,
              meta: { chatType: 'AUDIENCE' },
            },
            // 대화
            {
              path: '/ss/chat/general',
              name: 'ss-chat-general',
              component: ChatGeneralView,
              meta: { chatType: 'GENERAL' },
            },
            // 싱글
            {
              path: '/ss/chat/single',
              name: 'ss-chat-single',
              component: ChatSingleView,
              meta: { chatType: 'SINGLE' },
            },
          ],
        },
        // 구독 관리
        {
          path: '/ss/plan/manage',
          name: 'ss-plan-manage',
          component: SelfServicePlanSettingsView,
        },
        // 구독 정보
        {
          path: '/ss/plan/info',
          name: 'ss-plan-info',
          component: SelfServicePlanChangeView,
        },
        // 전체 통역 목록
        {
          path: '/ss/chat/list',
          name: 'ss-chat-list',
          component: SelfServiceChatListView,
        },
        // 사용 이력
        {
          path: '/ss/chat/history',
          name: 'ss-chat-history',
          component: SelfServiceHistoryView,
        },
        // 고객 센터
        {
          path: '/ss/contact',
          name: 'ss-contact',
          component: SelfServiceContactView,
        },
      ],
    },
    // 온보딩
    {
      path: '/ss/onboarding',
      name: 'ss-onboarding',
      component: SelfServiceOnboardingView,
    },
    // 이용약관
    {
      path: '/ss/policy',
      name: 'ss-policy',
      component: SelfServicePolicyView,
    },
  ];
}
